/* eslint-disable @typescript-eslint/no-explicit-any -- DIRECT-239681 */
import { isObject } from './isObject';
import { keys } from './keys';
/**
 * Мержит два объекта.
 * При совпадении ключей, значение из target перезаписывают значения из source.
 *
 * @param source Объект
 * @param target Объект
 * @param customizer Функция для обработки значения при мерже двух одинаковых ключей
 * @returns Объект, содержащий поля из обоих объектов
 * @example
 * ```typescript
 * import { merge } from '@direct-frontend/stdlib';
 *
 * merge(
 *     { a: 1, b: { c: 2 }, d: [1, 2, 3] },
 *     { b: { c: 'c', e: 'e' }, d: ['a', 'b', 'c'] }
 * );
 * // { a: 1, b: { c: 'c', e: 'e' }, d: ['a', 'b', 'c'] }
 * ```
 */
export function merge(source, target, customizer = () => undefined) {
    const result = { ...source, ...target };
    for (const key of keys(result)) {
        const sourceValue = source[key];
        const targetValue = target[key];
        if (isObject(sourceValue) && isObject(targetValue)) {
            result[key] = merge(sourceValue, targetValue, customizer);
        }
        else if (key in source && key in target) {
            const customizedValue = customizer(sourceValue, targetValue);
            result[key] = typeof customizedValue === 'undefined' ? targetValue : customizedValue;
        }
    }
    return result;
}
